<template>
  <div id="modeles" class="page">
    <section class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ol class="breadcrumb">
              <li>
                <router-link to="/">Accueil</router-link>
              </li>
              <li>les modèles OXYNOV</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="faq-pg-section section-padding-50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="section-title-s4">
              <h1>Garde-corps inox <div>les modèles OXYNOV</div></h1>
              <blockquote>
                Cliquez sur les vignettes ci-dessous pour zoomer sur les visuels et afficher les photos des éléments composant les <strong>GARDE-CORPS Oxynov</strong>. Mains courantes bois ou inox, remplissage par câbles ou par tubes, accessoires de montage...
              </blockquote>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <tabs>
              <tab name="Combinaisons" id="conbinaisons">
                <table id="table-conbinaisons" class="table table-bordered">
                  <thead>
                    <tr>
                      <th width="25%">&nbsp;</th>
                      <th width="25%">Remplissage par câbles inox <br>et tendeurs</th>
                      <th width="25%">Remplissage <br>par tubes inox</th>
                      <th width="25%">Remplissage par tubes inox <br>+ panneau de verre méthacrylate</th>
                    </tr>
                  </thead>
                  <tbody id="gallery-combinaisons">
                    <tr>
                      <td>
                        <h3>Main courante bois</h3>
                        <p>Les<strong> mains courantes bois Oxynov</strong> sont fabriquées en <strong>Sipo</strong>, un bois exotique originaire d'Afrique. D'une couleur rougeâtre à rosé, ce bois est particulièrement résistant à l'extérieur.</p>
                        <a href="#elements">En savoir +</a>
                      </td>
                      <td @click="openGallery('gallery-combinaisons', $event)">
                        <a href="/static/images/combinaisons/zoom/garde-corps-main-courante-bois-cables.jpg" title="Combinaison : Main courante bois / Remplissage par câbles inoxnextpreviousclose" class="zoom">
                          <img src="/static/images/combinaisons/garde-corps-main-courante-bois-cables.png" alt="" class="img-responsive">
                        </a>
                      </td>
                      <td @click="openGallery('gallery-combinaisons', $event)">
                        <a href="/static/images/combinaisons/zoom/garde-corps-main-courante-bois-tubes-inox.jpg" title="Combinaison : Main courante bois / Remplissage par tubes inox" class="zoom">
                          <img src="/static/images/combinaisons/garde-corps-main-courante-bois-tubes-inox.png" alt="" class="img-responsive">
                        </a>
                      </td>
                      <td @click="openGallery('gallery-combinaisons', $event)">
                        <a href="/static/images/combinaisons/zoom/garde-corps-main-courante-bois-tubes-et-verre.jpg" title="Combinaison : Main courante bois / Remplissage par tubes inox / Panneau de verre méthacrylate" class="zoom">
                          <img src="/static/images/combinaisons/garde-corps-main-courante-bois-tubes-et-verre.png" alt="" class="img-responsive">
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h3>Main courante inox</h3>
                        <p>La main courante inox OXYNOV existe en deux références, en <strong>inox 304</strong> (inox standard) ou<strong> inox 316</strong> (adapté aux milieux marins ou autres milieux exposés aux agents corrosifs.&nbsp; </p>
                        <a href="#elements" data-toggle="tab">En savoir +</a>
                      </td>
                      <td @click="openGallery('gallery-combinaisons', $event)">
                        <a href="/static/images/combinaisons/zoom/garde-corps-main-courante-inox-cables.jpg" title="Combinaison : Main courante inox / Remplissage par câbles inox" class="zoom">
                          <img src="/static/images/combinaisons/garde-corps-main-courante-inox-cables.png" alt="" class="img-responsive">
                        </a>
                      </td>
                      <td @click="openGallery('gallery-combinaisons', $event)">
                        <a href="/static/images/combinaisons/zoom/garde-corps-main-courante-inox-tubes-inox.jpg" title="Combinaison : Main courante inox / Remplissage par tubes inox" class="zoom">
                          <img src="/static/images/combinaisons/garde-corps-main-courante-inox-tubes-inox.png" alt="" class="img-responsive">
                        </a>
                      </td>
                      <td @click="openGallery('gallery-combinaisons', $event)">
                        <a href="/static/images/combinaisons/zoom/garde-corps-main-courante-inox-tubes-et-verre.jpg" title="Combinaison : Main courante inox / Remplissage par tubes inox / Panneau de verre méthacrylate" class="zoom">
                          <img src="/static/images/combinaisons/garde-corps-main-courante-inox-tubes-et-verre.png" alt="" class="img-responsive">
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </tab>
              <tab name="Les éléments" id="elements">
                <div class="row gallery">
                  <div class="col-md-4">
                    <h2>Les poteaux inox</h2>
                    <p>On distingue <strong>2 types de poteaux</strong>&nbsp;: <strong>fixation à plat</strong> ou <strong>latérale</strong>. Ils sont <strong>complètement pré-équipés en usine</strong>&nbsp;: </p>
                    <ul>
                      <li>Support de main courante orientable pour rampe de diamètre 42mm</li>
                      <li>5 supports de barre Ø22m avec 2 vis de serrage pour le passage soit de tubes Ø12mm, soit de câbles Ø4mm avec leurs manchons</li>
                      <li>Platine Ø100mm soudée et cache platine Ø105mm.</li>
                    </ul>
                    <p>Les <strong>poteaux inox</strong> sont d'un diamètre de 42mm et existent en <strong>inox 304</strong> (inox standard) ou <strong>inox 316</strong> (inox adapté aux milieux marins et corrosifs).</p>
                  </div>
                  <div class="col-md-8">
                    <div id="gallery-poteaux-inox" class="row">
                      <div class="col-md-3" v-for="(v, k) in galleries['gallery-poteaux-inox']" v-bind:key="k" @click="openGallery('gallery-poteaux-inox', $event)">
                        <a :href="'/static/images/elements/zoom/' + v.name" class="zoom" :title="v.title">
                          <img :src="'/static/images/elements/' + v.name" :alt="v.title" class="img-responsive">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row gallery">
                  <div class="col-md-4">
                    <h2>Les Mains courantes BOIS</h2>
                    <p><strong>Nos mains courantes bois Oxynov</strong> sont fabriquées en <strong>Hêtre</strong>, en <strong>Iroko </strong> ou en <strong>Ipé</strong>,un bois exotique noble originaire du brésil. Ce bois est un matériau chaleureux, particulièrement adapté aux ambiances intérieures. </p>
                    <p>Cette essence de <strong>couleur rougeâtre à rosé</strong> est particulièrement <strong>résistante à l'extérieur</strong>, elle&nbsp; est poncée très finement pour un <strong>toucher exceptionnel</strong>.&nbsp; Les rampes en bois s'assemblent entre elles avec un jeu de <strong>connecteurs</strong> mâles- femelles en nylon et acier inoxydable invisible. </p>
                  </div>
                  <div class="col-md-8">
                    <div id="gallery-main-courante-bois" class="row">
                      <div class="col-md-3" v-for="(v, k) in galleries['gallery-main-courante-bois']" v-bind:key="k" @click="openGallery('gallery-main-courante-bois', $event)">
                        <a :href="'/static/images/elements/zoom/' + v.name" class="zoom" :title="v.title">
                          <img :src="'/static/images/elements/' + v.name" :alt="v.title" class="img-responsive">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row gallery">
                  <div class="col-md-4">
                    <h2>Les Mains courantes INOX</h2>
                    <p>Les mains-courantes existent en <strong>inox 304</strong> (qualité standard) ou en <strong>inox 316</strong> (résistant aux agents corrosifs tels que l'air marin ou milieux industriels).</p>
                    <p> Le <strong>diamètre des tubes</strong> de la main courante inox sont identiques à ceux de la rampe en bois&nbsp;: <strong>42mm</strong>. Les connecteurs multiples permettent de s'adapter à toutes les configurations.&nbsp; </p>
                  </div>
                  <div class="col-md-8">
                    <div id="gallery-main-courante-inox" class="row">
                      <div class="col-md-3" v-for="(v, k) in galleries['gallery-main-courante-inox']" v-bind:key="k" @click="openGallery('gallery-main-courante-inox', $event)">
                        <a :href="'/static/images/elements/zoom/' + v.name" class="zoom" :title="v.title">
                          <img :src="'/static/images/elements/' + v.name" :alt="v.title" class="img-responsive">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row gallery">
                  <div class="col-md-4">
                    <h2>Remplissage par câbles & accessoires</h2>
                    <p>Le <strong>câble inox</strong> est une solution <strong>élégante</strong> en termes de <strong>design</strong>. Elle donne la sensation de légèreté au garde-corps, une ligne épurée qui se fond dans le paysage. Elle évoque bien sûr la marine et les balcons de bateaux.</p>
                    <p>Les <strong>câbles de 4mm</strong> se recoupent facilement avec la <strong>pince coupe câbles</strong> Oxynov. Ils s'assemblent et se fixent à l'aide des chapes sur mur ou poteaux. Des <strong>tendeurs</strong> permettent de&nbsp; faciliter la pose pour les longueurs supérieures à 15m. Enfin des <strong>manchons plastiques</strong> permettent d'éviter leur mouvement dans les <strong>supports de poteaux</strong>.&nbsp; </p>
                  </div>
                  <div class="col-md-8">
                    <div id="gallery-remplissage-cables" class="row">
                      <div class="col-md-3" v-for="(v, k) in galleries['gallery-remplissage-cables']" v-bind:key="k" @click="openGallery('gallery-remplissage-cables', $event)">
                        <a :href="'/static/images/elements/zoom/' + v.name" class="zoom" :title="v.title">
                          <img :src="'/static/images/elements/' + v.name" :alt="v.title" class="img-responsive">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row gallery">
                  <div class="col-md-4">
                    <h2>Remplissage par tubes, panneaux en verre & accessoires</h2>
                    <p>Le <strong>tube offre une solution plus rigide</strong> que le câble. Il permet surtout la mise en place des <strong>plaques de verre en méthacrylate</strong> pour une meilleure sécurité.</p>
                    <p>Les <strong>tubes</strong> s'assemblent entre eux à l'aide de <strong>manchons</strong> et de <strong>coudes orientables</strong> pour s'adapter à toutes les configurations. Les <strong>plaques de méthacrylates transparentes</strong> se fixent à l'aide de <strong>supports spécifiques</strong> qui sont directement posés sur les tubes. </p>
                  </div>
                  <div class="col-md-8">
                    <div id="gallery-remplissage-tubes" class="row">
                      <div class="col-md-3" v-for="(v, k) in galleries['gallery-remplissage-tubes']" v-bind:key="k" @click="openGallery('gallery-remplissage-tubes', $event)">
                        <a :href="'/static/images/elements/zoom/' + v.name" class="zoom" :title="v.title">
                          <img :src="'/static/images/elements/' + v.name" :alt="v.title" class="img-responsive">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>
            </tabs>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Modeles',
  data () {
    return {
      galleries: {
        'gallery-poteaux-inox': [
          { title: 'Poteaux INOX pour garde-corps - Fixation à plat', name: 'pot-poteau_inox_fixation_a_plat_POT020.jpg' },
          { title: 'Poteaux INOX pour garde-corps - Fixation latérale', name: 'pot-poteau_inox_fixation_laterale_POT021.jpg' },
          { title: 'Jonction poteau / main courante avec système de rotation pour utilisation sur rampant ou escaliers', name: 'pot_jonction_main_courante_rotation1.jpg' },
          { title: 'Jonction poteau / main courante avec système de rotation pour utilisation sur rampant ou escaliers', name: 'pot_jonction_main_courante_rotation2.jpg' },
          { title: 'Raccord de fixation pré-monté pour remplissage par tube ou câble inox', name: 'pot-poteau_inox_pontet.jpg' },
          { title: 'Platine de fixation avec cache inox prête à l\'emploi pour poteaux INOX de garde-corps - Fixation à plat', name: 'pot-poteau_inox_fixation_a_plat_cache1_POT020.jpg' },
          { title: 'Platine de fixation avec cache inox prête à l\'emploi pour poteaux INOX de garde-corps - Fixation à plat', name: 'pot-poteau_inox_fixation_a_plat_cache2_POT020.jpg' },
          { title: 'Tirefonds inox pour fixation de poteau de garde-corps', name: 'pot_tirefonds-inox-fixation-poteau-sur-sol-bois-TIR001.jpg' },
          { title: 'Chevilles inox pour fixation de poteaux de garde-corps', name: 'pot-chevilles-Inox-fixation-poteau-sur-sol-beton-CHE007.jpg' },
          { title: 'Support d\'angle pour main courante bois de garde corps', name: 'main-courante-bois-support-d-angle-90-degres.jpg' }
        ],
        'gallery-main-courante-bois': [
          { title: 'Rambarde / main courante bois pour garde-corps', name: 'main-courante-bois-rambarde-MAI004.jpg' },
          { title: 'Coude inox articulé pour main courante bois', name: 'main-courante-bois-coude-inox-articule-COU008.jpg' },
          { title: 'Manchon de liaison pour main courante bois', name: 'main-courante-bois-manchon-de-liaison-MAN002.jpg' },
          { title: 'Insert de liaison pour main courante bois', name: 'main-courante-bois-insert-de-liaison-INS001.jpg' },
          { title: 'Gabarit de perçage pour main courante bois', name: 'main-courante-bois-gabarit-de-percage-GAB001.jpg' },
          { title: 'Support mural pour fixation de main courante bois', name: 'main-courante-bois-support-mural-SUP002.jpg' },
          { title: 'Platine murale pour fixation de main courante bois', name: 'main-courante-bois-platine-murale.jpg' }
        ],
        'gallery-main-courante-inox': [
          { title: 'Main courante inox pour garde-corps', name: 'main-courante-inox-rambarde-MAI003.jpg' },
          { title: 'Coude articulé pour main courante inox', name: 'main-courante-inox-coude-articule-COU004.jpg' },
          { title: 'Coude à 90 degrés pour main courante inox', name: 'main-courante-inox-coude-90-degres-COU009.jpg' },
          { title: 'Raccord en T pour main courante inox', name: 'main-courante-inox-raccord-en-T-COU010.jpg' },
          { title: 'Manchon de liaison pour main courante inox', name: 'main-courante-inox-manchon-de-liaison-COU005.jpg' },
          { title: 'Embout pour main courante inox', name: 'main-courante-inox-embout-main-courante-EMB001.jpg' },
          { title: 'Support mural pour fixation de main courante inox', name: 'main-courante-inox-support-mural-SUP002.jpg' },
          { title: 'Platine murale pour fixation de main courante inox', name: 'main-courante-inox-platine-murale-PLA008.jpg' }
        ],
        'gallery-remplissage-cables': [
          { title: 'Exemple de remplissage par câble sur poteau inox avec possibilité de rotation pour rampant ou escaliers', name: 'garde_corps_inox_remplissage_cable1.jpg' },
          { title: 'Exemple de remplissage par câble sur poteau inox avec possibilité de rotation pour rampant ou escaliers', name: 'garde_corps_inox_remplissage_cable2.jpg' },
          { title: 'Câbles inox pour remplissage de garde-corps', name: 'garde-corps-inox-cables-CAB007.jpg' },
          { title: 'Manchon de caoutchouc pour remplissage par cables inox', name: 'garde-corps-inox-cables-manchon-caoutchouc-MAN001.jpg' },
          { title: 'Kit tendeurs pour fixation de cables inox', name: 'garde-corps-inox-cables-kit-fixation-cable-inox-ARR001.jpg' },
          { title: 'Kit de fixation pour cables inox avec chape', name: 'garde-corps-inox-cables-kit-fixation-avec-chape-ARR002.jpg' },
          { title: 'Tendeur de cable inox pour remplissage de garde-corps', name: 'garde-corps-inox-cables-tendeur-de-cable.jpg' },
          { title: 'Pince coupe cable oxynov', name: 'garde-corps-inox-cables-pince-coupe-cable.jpg' }
        ],
        'gallery-remplissage-tubes': [
          { title: 'Exemple de remplissage par tube sur poteau inox avec possibilité de rotation pour rampant ou escaliers', name: 'garde_corps_inox_remplissage_tube1.jpg' },
          { title: 'Exemple de remplissage par tube sur poteau inox avec possibilité de rotation pour rampant ou escaliers', name: 'garde_corps_inox_remplissage_tube2.jpg' },
          { title: 'Tube inox pour le remplissage de votre garde-corps', name: 'garde-corps-inox-tube-inox-TUB002.jpg' },
          { title: 'Coude articulé pour tube inox', name: 'garde-corps-inox-tube-coude-articule-pour-tube-COU006.jpg' },
          { title: 'Manchon de liaison pour tube de remplissage', name: 'garde-corps-inox-tube-manchon-de-liaison-COU007.jpg' },
          { title: 'Boule d\'ornement pour tube de remplissage', name: 'garde-corps-inox-tube-boule-ornement-BOU001.jpg' },
          { title: 'Platine murale pour fixation des tubes de remplissage', name: 'garde-corps-inox-tube-inox-PLA009.jpg' },
          { title: 'Panneau de verre méthacrylate', name: 'garde-corps-inox-tube-panneau-de-verre-acrylique-PAN001.jpg' },
          { title: 'Fixation pour panneau de verre méthacrylate', name: 'garde-corps-inox-tube-support-inox-pour-panneau-acrylique-SUP003.jpg' },
          { title: 'Colle forte loctite spécial Inox', name: 'garde-corps-inox-tube-inox-colle-loctite-special-inox-COL001.jpg' }
        ]
      }
    }
  },
  methods: {
    openGallery (id, event) {
      /* eslint-disable */
      event = event || window.event;
      var target = event.target || event.srcElement,
        link = target.src ? target.parentNode : target,
        options = {index: link, event: event},
        links = document.getElementById(id).querySelectorAll('a.zoom');
      blueimp.Gallery(links, options);
      event.preventDefault()
    }
  }
}
</script>

<style scoped>
#table-conbinaisons {
  border: 0;
}
#table-conbinaisons th {
  text-align: center;
  background: #025d90;
  color: #fff;
  border-bottom-width: 6px;
  border-bottom-color: #6A8590;
}
#table-conbinaisons th:first-child {
  background: #fff;
  border-left: 0;
}
#table-conbinaisons tbody > tr > td:first-child {
  background: #f7f7f7;
}
#table-conbinaisons h3 {
  font-size: 16px;
  text-transform: uppercase;
  margin-bottom: 15px;
  margin-top: 10px;
}
#table-conbinaisons p {
  font-size: 13px;
}
#table-conbinaisons img {
  transition: all .2s ease-in-out;
}
#table-conbinaisons a:hover img {
  transform: scale(1.1);
}
#modeles ul {
  list-style-position: initial;
  padding-left: 20px;
}
#modeles li {
  margin-bottom: 10px;
}
.gallery {
  border-bottom: dashed 1px #dddddd;
  padding-top: 30px;
}
.gallery:first-child {
  padding-top: 0;
}
.gallery:last-child {
  border-bottom: 0;
}
.gallery .zoom {
  border: solid 6px #f7f7f7;
  display: block;
  margin-bottom: 30px;
}
.gallery .zoom:hover {
  border-color: #025d90;
}
#modeles h2 {
  font-size: 22px;
  color: #025d90;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Modeles.vue